<template lang="html">
    <div class="login">
        <header class="header">
            <router-link :to="{ path: '/', params: { locale: $i18n.locale } }">
              <img class="header-logo" src="../../src/assets/telecloud-logo.png">
            </router-link>
        </header>
        <main class="main has-cover-background">
          <div class="container">
            <div class="row flex-center">
              <div class="card is-white col-mob-6 col-desk-4 col-auto">
                <div class="card-header">
                  <h1 class="card-title">{{ $t('views.error.title') }}</h1>
                </div>
                <div class="card-content">
                    <p>{{ $t('views.error.content') }}</p>
                    <router-link
                      :to="{ name: 'dashboard', params: { locale: $i18n.locale } }"
                      tag="button"
                      class="button is-gamma is-rounded">{{ $t('views.error.cta') }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </main>
    </div>
</template>

<script>
export default {
  name: 'error',
};
</script>

<style lang="scss">
  //Currently no way to use assets in styles folder
  .main {
    background-image: url('../assets/cloud-crop-city.jpg')
  }
</style>
